import { render, staticRenderFns } from "./BsCallout.vue?vue&type=template&id=67ef27aa&"
import script from "./BsCallout.vue?vue&type=script&lang=js&"
export * from "./BsCallout.vue?vue&type=script&lang=js&"
import style0 from "./BsCallout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports